import { httpClient, setAuthAndReinit } from './../httpClient';

/**
 * Session-based login (v2). Creates a revocable session. Sends user-agent as deviceInfo.
 */
export const postSessionLogin = credentials => {
  const body = {
    email: credentials.email,
    password: credentials.password,
    deviceInfo: { userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '' }
  };
  if (credentials.token) body.token = credentials.token;
  return httpClient
    .post('/auth/session-login', body)
    .then(response => {
      setAuthAndReinit(response.data);
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const postSignUp = signUpDetails => {
  return httpClient
    .post('/auth/register', signUpDetails)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const roleCheck = role => {
  return httpClient
    .get(`/role-check?role=${role}`)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getForgotPasswordToken = ({ email, host }) => {
  return httpClient
    .post('/auth/forgot-password', { email, host })
    .then(res => {
      return res;
    })
    .catch(error => {
      return error;
    });
};

export const resetPassword = (token, { password }) => {
  return httpClient
    .post('/auth/reset-password/' + token, { password })
    .then(res => {
      return res;
    })
    .catch(error => {
      return error;
    });
};

// Add a function to call backend (oldpassword, password)
export const userProfileResetPassword = (oldpassword, password) => {
  return httpClient
    .post('/auth/userprofile-reset-password', { oldpassword, password })
    .then(res => {
      return res;
    })
    .catch(error => {
      return error;
    });
};

export const getCheckIsUserPasswordExpired = username => {
  return httpClient.get('/auth/check-password-expired', { params: { username } }).then(res => res.data);
};

export const postChangeExpiredPassword = (username, password) => {
  return httpClient.post('/auth/reset-expired-password', { username, password }).then(res => res.data);
};

/**
 * Logout: revokes current session (v2) when token is sent. Optional deviceInfo (user-agent) for push cleanup.
 */
export const postLogout = (body = {}) => {
  return httpClient
    .post('/auth/logout', body)
    .then(res => res)
    .catch(() => {});
};

/**
 * List all sessions for the current user (auth required).
 */
export const getSessions = () => {
  return httpClient.get('/auth/sessions').then(res => res.data);
};

/**
 * Revoke a session by id. Returns 204 on success; 404 when not found or already revoked.
 */
export const revokeSession = sessionId => {
  return httpClient.delete(`/auth/sessions/${sessionId}`);
};
